export default {
  init: function () {
    const t = this
    const mainNav = document.querySelector('.main-nav')
    
    t.header = document.querySelector('.site-header')
    t.headerHover = document.querySelector('.header-hover')

    if (!mainNav) return
    
    t.hoverSubMenu()
    
    t.hoverHeader()
    
    t.search()
    
    t.openCloseMenu()
  },
  
  hoverSubMenu: function() {
    let t = this
    
    Array.from(t.header.querySelectorAll('.menu-item-has-children .sub-menu .menu-item-has-children .sub-menu')).forEach(subItemsList => {
      subItemsList.addEventListener('mouseover', (e) => {
        subItemsList.parentNode.classList.add('active-hover')
      })
      subItemsList.addEventListener('mouseout', () => {
        subItemsList.parentNode.classList.remove('active-hover')
      })
    })
  },
  
  hoverHeader: function() {
    let t = this
    
    const subMenus = t.header.querySelectorAll('.sub-menu')
    t.hoverHeaderCalc(subMenus)
    
    window.addEventListener('resize', () => {
      t.hoverHeaderCalc(subMenus)
    }, true);
  },

  hoverHeaderCalc: function(subMenus) {
    let t = this

    let maxHeightSubMenus = 0
    Array.from(subMenus).forEach(subMenuEl => {
      maxHeightSubMenus = subMenuEl.offsetHeight > maxHeightSubMenus ? subMenuEl.offsetHeight : maxHeightSubMenus
    })
    t.headerHover.style.minHeight = `${ maxHeightSubMenus + 120 }px`
  },
  
  hoverToggleHeader: function() {
    let t = this

    t.headerHover.toggleAttribute('data-active-hover')
  },
  
  search: function() {
    let t = this
    
    const searchBtn = document.querySelector('[data-search-button]')
    const searchWrap = document.querySelector('[data-search-wrap]')
    
    searchBtn.addEventListener('click', () => {
      t.hoverToggleHeader()

      if (searchWrap.style.height && searchWrap.style.height != '0px') {
        searchWrap.style.height = 0
      }
      else {
        searchWrap.style.height = searchWrap.scrollHeight + 'px'
      }
    })
    
    window.addEventListener('scroll', (e) => {
      if (searchWrap.style.height && searchWrap.style.height != '0px') {
        searchWrap.style.height = 0
        t.hoverToggleHeader()
      }
    })
  },
  
  isExpanded: function () {
    let t = this
    return t.header.hasAttribute('aria-expanded')
  },
  
  openCloseMenu: function () {
    let t = this
    const openMenuBtn = document.getElementById('menu-toggle')

    openMenuBtn.addEventListener('click', () => {
      t.header.toggleAttribute('aria-expanded')
    })
    
    t.openSubMenuLists()
  },
  
  openSubMenuLists: function() {
    let t = this
    const subMenuLinks = document.querySelectorAll('.menu-item-has-children')

    Array.from(subMenuLinks).forEach(subMenuLink => {
      subMenuLink.querySelector('a').addEventListener('click', (e) => {
        if(t.isExpanded() && window.innerWidth < 1024) {
          e.preventDefault()
          subMenuLink.toggleAttribute('aria-active-sub-menu')
        }
      })
    })
  }
}
